import { IEditSalesExpensePayload, IMySalesExpenseListSearch, ISalesExpenseListSearch, IUpdateSalesExpenseStatus } from "../../../../types/sales/salesExpenseInterface";
import api from "../../../../lib/api";

export const createSalesExpenseApi = async (data: FormData) => {
  return await api.post(`accounts/expense/sales-expense`, data);
};

// export const getSalesExpenseListApi = async (data: ISalesExpenseListSearch) => {
//   return await api.get(`expense/sales-expense/${data.page}/${data.pageLimit}?hub_id=${data.hub_id}&branch_id=${data.branch_id}&search=${data?.search ?? ""}`)
// }

export const getSalesExpenseListApi = async (data: ISalesExpenseListSearch) => {
  return await api.get(`accounts/expense/sales-expense/${data.page}/${data.pageLimit}`, {
    params: {
      hub_id: data?.hub_id.toString(),
      branch_id: data?.branch_id.toString(),
      status: data?.status,
      search: data?.search ?? ""
    }
  })
}

export const getMySalesExpenseListApi = async (data: IMySalesExpenseListSearch) => {
  return await api.get(`accounts/expense/sales-expense/my-expense/${data.page}/${data.pageLimit}`, {
    params: {
      status: data?.status,
      search: data?.search ?? ""
    }
  })
}

export const getSalesExpenseDataByIdApi = async (id: number) => {
  return await api.get(`accounts/expense/sales-expense/${id}`)
}

export const editSalesExpenseDataByIdApi = async (payload: IEditSalesExpensePayload) => {
  return await api.put(`accounts/expense/sales-expense/${payload.id}`, payload.data);
};

export const updateSalesExpenseStatusApi = async (payload: IUpdateSalesExpenseStatus) => {
  return await api.patch(`accounts/expense/sales-expense/${payload.id}`, payload.data);
};
